import { Menu, MenuItem } from '@material-ui/core';
import { EtapaProjeto, indexOfEtapa } from 'models/projeto';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import languageValues from 'utils/LanguageUtils';
import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
  PROJECT_STATUS_REJEITADO,
} from '../../library/ProjectStatus';
import { getStepSlug } from '../../library/ProjectSteps';
import { projectEdit, projectFluxControlRoute } from '../../library/Routes';
import StatusIcon from '../ProjetoItem/StatusIcon';
import styles from './ProjectStepsMenu.scss';
const rootClassName = styles.rootClassName;

class ProjectStepsMenu extends Component {
  getEtapaByIndex(stepIndex) {
    if (this.props.flgNovoTemplate) {
      const name =
        languageValues.pages.projetos.etapas[
          Object.values(EtapaProjeto)[stepIndex]
        ].name;
      return typeof name === 'function' ? name(this.props.flgInfantil) : name;
    }
    return [
      this.props.languageValues.preCadastro,
      this.props.languageValues.etapa1,
      this.props.languageValues.etapa2_1,
      this.props.languageValues.etapa2_2,
      this.props.languageValues.etapa3,
      this.props.languageValues.etapa4,
      this.props.languageValues.etapa5,
      this.props.languageValues.etapa6,
      this.props.languageValues.etapa7,
      this.props.languageValues.etapa8,
      this.props.languageValues.etapa9,
    ][stepIndex];
  }

  isTotalApproved() {
    const croppedAvaliacoes = this.props.flgNovoTemplate
      ? this.props.avaliacoes.slice(0, indexOfEtapa(EtapaProjeto.revisao))
      : this.props.avaliacoes.slice(0, 10);
    return (
      !croppedAvaliacoes.includes(PROJECT_STATUS_RASCUNHO) &&
      !croppedAvaliacoes.includes(PROJECT_STATUS_PENDENTE) &&
      !croppedAvaliacoes.includes(PROJECT_STATUS_REJEITADO)
    );
  }

  render() {
    return (
      <Menu
        open={this.props.open}
        onClose={this.props.onClose}
        anchorEl={this.props.anchorEl}
      >
        {this.props.avaliacoes.map((avaliacao, index) => {
          const statusIndex = this.isTotalApproved()
            ? PROJECT_STATUS_APROVADO
            : avaliacao;
          return (
            <MenuItem
              onClick={() => {
                if (this.props.flgNovoTemplate) {
                  this.props.history.push(
                    projectFluxControlRoute.getURLWithParams({
                      id: this.props.idProjeto,
                      step: Object.values(EtapaProjeto)[index],
                    })
                  );
                } else {
                  this.props.history.push(
                    projectEdit.getURLWithParams(
                      this.props.idProjeto,
                      getStepSlug(index)
                    )
                  );
                }
              }}
              key={index}
              selected={
                this.props.stepIndex && this.props.stepIndex === index
                  ? true
                  : false
              }
              disabled={
                this.props.stepIndex && this.props.stepIndex === index
                  ? true
                  : false
              }
            >
              <StatusIcon
                status={statusIndex}
                className={
                  rootClassName +
                  '-status-icon ' +
                  rootClassName +
                  '-menu-status-icon'
                }
              />
              {this.getEtapaByIndex(index)}
            </MenuItem>
          );
        })}
      </Menu>
    );
  }
}

ProjectStepsMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  avaliacoes: PropTypes.array.isRequired,
  idProjeto: PropTypes.number.isRequired,
  anchorEl: PropTypes.object,
  currStepIndex: PropTypes.number,
  flgNovoTemplate: PropTypes.bool,
  flgInfantil: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

export default connect(mapStateToProps)(withRouter(ProjectStepsMenu));
